import React, { useContext, useEffect, useState } from 'react'

import { Button, Row  } from 'antd'

import createOperation from '../../marketing/operations/MarketingOperationCreate'
import TableMarketingOperations from '../../tables/TableMarketingOperations'
import MarketingEmpty from '../../marketing/MarketingEmpty'
import { apiGetOperations } from '../../../helpers/Api'
import DashboardLayout from '../../DashboardLayout'
import { Context } from '../../../helpers/Context'

export default function PageMarketingOperations() {
   
   const [refreshOperations, setRefreshOperations] = useState(0);
   const [operations, setOperations] = useState([]);
   const [loading, setLoading] = useState(false)
   
   const contextValue = useContext(Context);
   const { publicCode, errorNotification } = contextValue;
   
     /////////////////////////////////////////////////////////////////////////////////////////// 
                 //////////////////// recupero i dati del pubblico ///////////////
     /////////////////////////////////////////////////////////////////////////////////////////// 
     
     useEffect(() => {
       
       setLoading(true);

       if (!publicCode || publicCode === "") {
         setLoading(false)
         return
       };
   
       try {
        (async () => {
          const res = await apiGetOperations(publicCode);
          
          if (res && !res?.message) {
            setOperations(res.operations)
            setLoading(false)
          } else {
             setLoading(false)
             errorNotification(res.message)
          }
        })();
       } catch (error) {
         errorNotification(JSON.stringify(error))
         console.log(error)
       }
   
     },[refreshOperations])
     
     /////////////////////////////////////////////////////////////////////////////////////////// 
                 //////////////////// recupero i dati del pubblico ///////////////
     ///////////////////////////////////////////////////////////////////////////////////////////

  const handleRefreshOperations = () => {
    setRefreshOperations(refreshOperations + 1)
  }
  
   const onSave  = () => {
     handleRefreshOperations();
   }
   
  return (
     <DashboardLayout hideShops={true}>
      <Row className='p-20'>
        <div className='di-card mb-20 w-100'>
              {!operations || operations.length === 0 ? 
                 
               //------------ aggiungi un operazione quando non ne hai ancora fatte -----------
              <MarketingEmpty
                contextValue={contextValue}
                isOperation={true}
                onSave={onSave}
              />
               //------------ aggiungi un operazione quando non ne hai ancora fatte -----------
                 
            :
                 <div>
                    
                     <div className='flex flex-wrap align-center justify-end mb-20 gap-20'>
                        <Button
                           onClick={() => {
                              createOperation({ context: contextValue, onSave: onSave })
                            }
                           }
                           type='primary'
                        >
                              + Crea Operazione
                        </Button>
                    </div>
                    
                  <TableMarketingOperations
                    onSave={handleRefreshOperations}
                    onChange={handleRefreshOperations}
                    operationsData={operations}
                    setLoading={setLoading}
                    loading={loading}
                  />
               </div>
              }
         </div>
      </Row>
     </DashboardLayout>
  )
}
